var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "meta-insights-channel-detail" } },
    [
      _c("AppBreadCrumb", {
        staticClass: "visitor-detail-bread-crumb",
        attrs: {
          paths: [{ title: "Meta Insights Channel Detail" }],
          select: true,
        },
      }),
      _vm._v(" "),
      _vm.channel
        ? _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "toolbar" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _c(
                    "IconButton",
                    {
                      attrs: {
                        "on-click": function () {
                          return _vm.$router.push("/integrations/meta-insights")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("chevron_left"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon-container" },
                    [_c("MetaIcon")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("metaInsights.channelTitle")) +
                        " : " +
                        _vm._s(_vm.channel.name) +
                        "\n                    "
                    ),
                    _vm.adAccountName
                      ? _c("span", { staticClass: "ad-account" }, [
                          _vm._v("— " + _vm._s(_vm.adAccountName)),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = true
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("whatsappChannel.deleteChannel")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "channel-content" },
              [
                _c("SidebarChild", {
                  attrs: {
                    items: _vm.menuItems,
                    "selected-item": _vm.currentTab,
                    focusActive: true,
                  },
                  on: {
                    selected: function (i) {
                      return (_vm.currentTab = i.key)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-content" },
                  [
                    _vm.currentTab === _vm.MenuKeys.OVERVIEW
                      ? _c("Overview", {
                          attrs: { channel: _vm.channel },
                          on: {
                            "change-tab": function (key) {
                              return (_vm.currentTab = key)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentTab === _vm.MenuKeys.AUDIENCE
                      ? _c("Audience", { attrs: { channel: _vm.channel } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentTab === _vm.MenuKeys.PERFORMANCE
                      ? _c("Performance", { attrs: { channel: _vm.channel } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentTab === _vm.MenuKeys.CAMPAIGNS
                      ? _c("CampaignsList", {
                          attrs: { channel: _vm.channel },
                          on: { "drill-down": _vm.onDrillDown },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentTab === _vm.MenuKeys.ADSETS
                      ? _c("AdSetsList", {
                          attrs: {
                            channel: _vm.channel,
                            "campaign-id": _vm.filterCampaignId,
                          },
                          on: {
                            "drill-down": _vm.onDrillDown,
                            "clear-filter": function ($event) {
                              _vm.filterCampaignId = null
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentTab === _vm.MenuKeys.ADS
                      ? _c("AdsList", {
                          attrs: {
                            channel: _vm.channel,
                            "adset-id": _vm.filterAdsetId,
                          },
                          on: {
                            "clear-filter": function ($event) {
                              _vm.filterAdsetId = null
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentTab === _vm.MenuKeys.DETAIL
                      ? _c("UpdateDetail", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentTab === _vm.MenuKeys.VISIBILITY
                      ? _c("Visibility", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            icon: "exclamation-circle",
            title: _vm.$t("metaInsights.channelTitle"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteMetaInsightsChannel },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("whatsappChannel.deleteChannel")))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }